import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

export interface FormDataSections {
  cadastro: Record<string, unknown>;
  documentosObrigatorios: Record<string, unknown>;
  documentosBonus: Record<string, unknown>;
  documentosBonusExtra: Record<string, unknown>;

  docBonus: Record<string, unknown>;
  docBonusExtra: Record<string, unknown>;
  docsObrigatorios: Record<string, unknown>;
}

export interface FormContextValue {
  formData: FormDataSections;
  updateFormData: (section: keyof FormDataSections, data: Record<string, unknown>) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const FormContext = createContext<FormContextValue | undefined>(undefined);

export const useForm = (): FormContextValue => {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};

interface FormProviderProps {
  children: ReactNode;
}

export const FormProvider = ({ children }: FormProviderProps): React.ReactElement => {
  const [formData, setFormData] = useState<FormDataSections>({
    cadastro: {},
    documentosObrigatorios: {},
    documentosBonus: {},
    documentosBonusExtra: {},
    docBonus: {},
    docBonusExtra: {},
    docsObrigatorios: {},
  });

  const [isLoading, setIsLoading] = useState(false);

  const updateFormData = (
    section: keyof FormDataSections,
    data: Record<string, unknown>
  ): void => {
    setFormData((prev) => ({
      ...prev,
      [section]: data,
    }));
  };

  useEffect(() => {
    const responsavel = localStorage.getItem("responsavelQuestionaro");
    const cargo = localStorage.getItem("cargoResponsavel");

    if (responsavel || cargo) {
      setFormData((prev) => ({
        ...prev,
        cadastro: {
          ...prev.cadastro,
          responsavel: responsavel || "",
          cargo: cargo || "",
        },
      }));
    }
  }, []);

  return (
    <FormContext.Provider
      value={{
        formData,
        updateFormData,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
